import Status from "components/base/Status";
import moment from "moment";
import { Link } from "react-router-dom";
import PlanLines from "./PlanLines";

const AdditionPlanView = ({ plan }) => {
  return (
    <div>
      <div>
        <div className="flex items-center space-x-4">
          <h5>
            <Link to={`/order-scheduler/plans/${plan.id}`}>
              #{plan.id} {plan.name}
            </Link>
          </h5>

          <Status status={plan.state} />
        </div>

        <div className="flex space-x-8 items-center mt-2">
          <div className="flex space-x-4 items-center">
            <label>Start Date: </label>
            <span>{moment(plan.startDate).format("YYYY-MM-DD")}</span>
          </div>
        </div>

        <div className={`mt-2 ${plan.state === "DRAFT" ? "opacity-50" : ""}`}>
          <PlanLines
            originalPlan={plan}
            lines={plan.lines}
            requiredCertificateTypes={plan.requiredCertificateTypes}
            odooSalesOrderWarehouseId={plan.odooSalesOrderWarehouseId}
            disabled
          />
        </div>
      </div>
    </div>
  );
};

export default AdditionPlanView;
